import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarcodeScannerComponent } from './barcode-scanner.component';
import { ScannerComponent } from './scanner/scanner.component';
import { BarcodeScannerService } from './barcode-scanner.service';
import { UploadImgModule } from '../../pages/A2-utils/upload-img/upload-img.module';
import { UploadImgService } from 'app/pages/A2-utils/upload-img/upload-img.service';

@NgModule({
  imports: [CommonModule, UploadImgModule],
  declarations: [BarcodeScannerComponent, ScannerComponent],
  exports: [BarcodeScannerComponent],
  providers: [BarcodeScannerService, UploadImgService]
})
export class BarcodeScannerModule { }



// WEBPACK FOOTER //
// ./src/app/utils/barcode-scanner/barcode-scanner.module.ts